import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
const LinkButton = styled(Button)({
  color: 'inherit',
  textTransform: 'none',
  padding: 0,
  minWidth: 'unset',
  backgroundColor: 'transparent',
  border: 'none',
  textDecoration: 'underline',
  '&:hover': {
    backgroundColor: 'transparent',
    border: 'none',
    textDecoration: 'underline',
  },
  '&:focus': {
    backgroundColor: 'transparent',
    border: 'none',
  },
});

export default LinkButton;
